import { render, staticRenderFns } from "./CustomerListItemCard.vue?vue&type=template&id=7649274c&scoped=true"
import script from "./CustomerListItemCard.vue?vue&type=script&lang=js"
export * from "./CustomerListItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7649274c",
  null
  
)

export default component.exports